const Activation = ({
  dateActivated = '',
  dateActivatedTimestamp = '',
  dateUpdated = '',
  dateUpdatedTimestamp = '',
  daysExtended = 0,
  expirationDate = '',
  expirationDateTimestamp = '',
  listingAlias = '',
} = {}) => ({
  dateActivated: String(dateActivated),
  dateActivatedTimestamp: String(dateActivatedTimestamp),
  dateUpdated: String(dateUpdated),
  dateUpdatedTimestamp: String(dateUpdatedTimestamp),
  daysExtended: Number(daysExtended),
  expirationDate: String(expirationDate),
  expirationDateTimestamp: String(expirationDateTimestamp),
  listingAlias: String(listingAlias),
});

const PaymentSummary = ({
  activeProductType = -1,
  expirationDate = '',
  expirationDateTimestamp = '',
  hasProcessedNewPayment = false,
  isPaymentValid = false,
  message = '',
  metroidProductId = '',
  paymentStatus = '',
  transactionId = '',
  userBrand = '',
  userToken = '',
} = {}) => ({
  activeProductType: Number(activeProductType),
  expirationDate: String(expirationDate),
  expirationDateTimestamp: String(expirationDateTimestamp),
  hasProcessedNewPayment: Boolean(hasProcessedNewPayment),
  isPaymentValid: Boolean(isPaymentValid),
  message: String(message),
  metroidProductId: String(metroidProductId),
  paymentStatus: String(paymentStatus),
  transactionId: String(transactionId),
  userBrand: String(userBrand),
  userToken: String(userToken),
});

const ChargeAndActivateListing = ({
  activation = {},
  isInMaintenanceMode = false,
  listingActivationFailed = false,
  paymentSummary = {},
  paymentSummaryFailed = false,
} = {}) => ({
  activation: Activation(activation),
  isInMaintenanceMode: Boolean(isInMaintenanceMode),
  listingActivationFailed: Boolean(listingActivationFailed),
  paymentSummary: PaymentSummary(paymentSummary),
  paymentSummaryFailed: String(paymentSummaryFailed),
});

export default ChargeAndActivateListing;

export type ChargeAndActivateListingProps = ReturnType<typeof ChargeAndActivateListing>;
